import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import api from '../../services/instance';

const Footer = () => {

    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ text: "", type: "" });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!phone || phone.length < 10) {
            setMessage({ text: "Please enter a valid phone number.", type: "error" });
            return;
        }
        setLoading(true);
        setMessage({ text: "", type: "" });
        try {
            const res = await api.post('/send-app-link', { phone });
            setMessage({ text: res.data.message, type: "success" });
            setPhone("");
        } catch (err) {
            setMessage({
                text: err.response?.data?.message || "Failed to send. Please try again.",
                type: "error"
            });
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <div className="footer-box">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-5">
                            <h1 className="footer-text-top">Send App Link</h1>
                            {/* <form action className="">
                                <div className='form-box-inputs'>
                                    <input type="number" defaultValue={+1} className="phone-code" />
                                    <input type="number" placeholder="Enter phone number" className="phone-number" />
                                </div>

                                <div className='gap-top-footer'>
                                    <button className='btn btn-primary' type='submit'>Send</button>
                                </div>
                            </form> */}
                            <form onSubmit={handleSubmit}>
                                <div className="form-box-inputs">
                                    <PhoneInput
                                        defaultCountry="us"     // Default flag (you can set "pk" for Pakistan)
                                        value={phone}
                                        onChange={(phone) => setPhone(phone)}
                                        inputClassName="phone-input" // Optional custom class
                                    />
                                </div>

                                {message.text && (
                                    <p style={{ color: message.type === "success" ? "green" : "red", fontSize: "13px", marginTop: "5px" }}>
                                        {message.text}
                                    </p>
                                )}
                                <div className="gap-top-footer">
                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                        {loading ? "Sending..." : "Send"}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4">
                            <h1 className="footer-text-top">Social Media Link</h1>
                            <div className="social-links">
                                <a href="#">
                                    <i className="fa-brands fa-instagram instagram-icon" />
                                </a>
                                <a href="#">
                                    <i className="fa-brands fa-facebook-f facebook-icon" />
                                </a>
                                <a href="#">
                                    <i className="fa-brands fa-x-twitter twiter-icon"></i>
                                </a>
                                <a href="#">
                                    <i className="fa-brands fa-linkedin-in linkedin-icon" />
                                </a>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-3">
                            <h1 className="footer-text-top">Quick Link</h1>
                            <ul className="footer-links">
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to='/terms-and-conditions'>Terms and Conditions</Link></li>
                                <li><Link to="/about-us">About Us</Link></li>
                                <li><Link to="/contact">Contact Us</Link></li>
                                <li><a href="#">Sitemap</a></li>
                            </ul>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-4">
                            <h1 className="footer-text-top">Popular Places</h1>
                            <ul className="footer-links">
                                <li><a href="#">Los Angeles</a></li>
                                <li><a href="#">Miami</a></li>
                                <li><a href="#">Las Vegas</a></li>
                                <li><a href="#">New York</a></li>
                                <li><a href="#">San Diego</a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="row footer-top-line-text">
                        <div className="col-md-12">
                            <p className="copyright-text-main">© 2018 ISIT Corporation. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer